<!--  -->
<template>
  <div class="relation_box">
    <div class="bang_box">
      <div>
        <el-input v-model="pagequery.keywords" class="titiltip" placeholder="主号搜索appId/ghId/公众号名称" />
        <el-input v-model="pagequery.keywords_rel" class="titiltip" placeholder="副号搜索appId/ghId/公众号名称" />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="addband">新建绑定</el-button>
      </div>

    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="app_id"
        label="主号app_id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="account_name"
        label="主号公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="relation_app_id"
        label="副号app_id"
        width="200"
        align="center"
      />
      <el-table-column
        prop="account_name_rel"
        label="副号公众号名称"
        width="200"
        align="center"
      />
      <el-table-column
        prop="platform_name"
        label="副号平台"
        width="150"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="状态"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.status == 1" class="el-icon-success" style="color:#67C23A" />
          <i v-if="scope.row.status == 2" class="el-icon-error" style="color:#F56C6C" />
          {{ scope.row.status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        width="200"
        align="center"
      />
      <el-table-column
        prop="creator"
        label="创建人"
        width="100"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == 1" type="danger" size="mini" @click="unband(scope.row.id)">解绑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="templatetotalre"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
    <el-dialog
      title="新建绑定"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      width="30%"
    >
      <addrelation @updata="updata" @updataerror="updataerror" />
    </el-dialog>
    <el-dialog
      title="绑定公众号失败列表"
      :visible.sync="erroraccount"
      width="60%"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <errorlist ref="errorlistview" />
    </el-dialog>
  </div>
</template>

<script>
import { bangaccountlist, mainunbindsub } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addrelation from './components/addrelation.vue'
import errorlist from '../redEnvelopeActivity/components/errorlist.vue'
export default {
  components: { PaginationRight, addrelation, errorlist },
  data() {
    return {
      tableData: [],
      templatetotalre: null,
      dialogVisible: false,
      erroraccount: false,
      pagequery: {
        page: 1,
        pageSize: 10,
        keywords: null,
        keywords_rel: null
      }
    }
  },
  created() {
    this.customercreatlistall()
  },
  mounted() {

  },
  methods: {
    async customercreatlistall() {
      const data = await bangaccountlist(this.pagequery)
      this.tableData = data.data.list
      this.templatetotalre = data.data.total
      console.log('data', data)
    },

    fetchPageSizeone(e) {
      this.pagequery.pageSize = e
      this.customercreatlistall()
    },
    fetchCurrentPageone(e) {
      this.pagequery.page = e
      this.customercreatlistall()
    },
    search() {
      this.pagequery.page = 1
      this.customercreatlistall()
    },
    reast() {
      this.pagequery.page = 1
      this.pagequery.pageSize = 10
      this.pagequery.keywords = null
      this.pagequery.keywords_rel = null
      this.customercreatlistall()
    },
    unband(id) {
      this.$confirm('此操作将解绑, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        mainunbindsub({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '解绑成功!'
          })
          this.customercreatlistall()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解绑'
        })
      })
    },
    addband() {
      this.dialogVisible = true
    },
    updata() {
      this.dialogVisible = false
      this.customercreatlistall()
    },
    updataerror(file) {
      console.log('file', file)
      this.dialogVisible = false
      this.customercreatlistall()
      this.erroraccount = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.errorlistview.send(file)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.titiltip{
  width: 260px;
  margin-right: 10px;
}
.relation_box{
  padding: 30px;
}
.bang_box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
</style>
